<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="M19.4 4.1h-1V2h-2.2v2.1H7.8V2H5.7v2.1h-1a2 2 0 0 0-2.2 2.1V20a2 2 0 0 0 2.1 2h14.8a2 2 0 0 0 2.1-2.1V6.2a2 2 0 0 0-2.1-2m0 15.8H4.6V8.3h14.8z"
    />
    <path
      d="m12 17-2.1 1.2-.3.1h-.3L9 18v-.3l.6-2.4-2-1.7v-.8H8l2.5-.3 1-2.3.1-.2.3-.1h.3l.2.3 1 2.3 2.5.2.2.1.2.6-.1.2-2 1.7.6 2.4v.3l-.2.2-.3.1H14z"
    />
  </svg>
</template>
